import AMark from "@/components/AMark";

// Arjuna Space "A + data bits" emblem (brand mark)
export function Logo({ className = "h-8 w-8", withWordmark = false }) {
  return (
    <span className="inline-flex items-center gap-3">
      <AMark
        className={`${className} text-white drop-shadow-[0_0_10px_rgba(0,229,255,0.35)]`}
      />
      {withWordmark && (
        <span className="font-heading text-sm font-semibold tracking-[0.35em] text-white">
          ARJUNA<span className="text-arjuna-teal"> SPACE</span>
        </span>
      )}
    </span>
  );
}

export default Logo;
